import { IDashboardConstants } from '@typings/dashboard';

const dashboardConstants: IDashboardConstants = {
    WIDGET_DEFAULT_LIMIT: 5,
};

export default dashboardConstants;
